import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, parseClasses } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import { Checkbox } from './Checkbox';
import FieldLabel from './FieldLabel';

import RibbonCollection from '../ui_items/RibbonCollection';

const SelectMultiple = ({ items, ...props }) => {
	useCSS('assets/select_multiple.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ selected, setSelected ] = useState(props?.selected ?? []);
	const [ display_list, setDisplayList ] = useState(false);

	if(items.length == 0) return null;

	const autosort_items = props?.autosort_items ?? true;

	const sorted_items = (autosort_items) ? [ ...items ].sort((a, b) => {
		const title_a = a?.title ?? a.name;
		const title_b = b?.title ?? b.name;

		if(title_a < title_b) return -1;
		if(title_a > title_b) return 1;
		return 0;
	}) : [ ...items ];

	const toggleItem = (item_id) => {
		let _selected = [ ...selected ];
		if(_selected.includes(item_id)) {
			_selected = _selected.filter((i) => (i != item_id));
		} else {
			_selected.push(item_id);
		}

		setSelected(_selected);
		
		if(props.onChange != undefined) props.onChange(_selected);
	};

	let classname = props?.classname ?? 'multipicker_list';
	classname = parseClasses(classname, props._class, 'multipicker');

	return (
		<div class={classname}>
			<div class="react_field type_text">
				<div class="input text multiselect_filter in_top width_100">
					<div class="field_container this_text" onClick={() => setDisplayList(true)}>
						<FieldLabel>{props.children}</FieldLabel>

						<RibbonCollection
							items={items.filter((i) => (selected.includes(i.id)))}
							paint_if_empty={true}
							empty_message={i18n("Filter by tag")}
							_class={{ other:'common_form_item' }}
						/>
					</div>
				</div>
			</div>

			{(display_list) && (
				<>
					<div class="options_tapper" onClick={() => setDisplayList(false)} />

					<div class="options_list">
						<ul>
							{sorted_items.map((item, i) => {
								const id = item?.id ?? i;
								const color = item?.color ?? 'rgba(var(--text-color-rgb), 1)';

								return (
									<li key={`item_${id}`} class="single_item" onClick={() => toggleItem(id)}>
										<Checkbox
											name={`item_${id}`}
											_class={{ first:true, other:'gui_remove_pointer_events' }}
											value={selected.includes(id) ? true : false}
										>{item?.title ?? item?.name ?? `${i18n("Option")} ${i + 1}`}</Checkbox>

										{(color !== false) && (
											<span
												class="tag_color ep-circle gui_small_icon"
												style={{ color }}
											/>
										)}
									</li>
								)
							})}
						</ul>
					</div>
				</>
			)}
		</div>
	)
};

export default injectIntl(SelectMultiple);